export default "__VITE_ASSET__6e450d27__"